module.exports = "/images/vendor/flag-icon-css/flags/4x3/gt.svg?656c9899d22b166292448de76509d46c";